// @flow
/** @jsx h */

import { h, Component } from 'preact'

import { Button } from '../../../../../components/Button/Button'

import styles from './RetryButton.css'

type Props = {
  onClick: () => void,
  children?: ?any
}

export class RetryButton extends Component<Props> {
  render () {
    return (
      <Button onClick={this.props.onClick} className={styles.retryButton}>
        <svg width='15' height='15' aria-hidden='true'>
          <use xlinkHref='#nrk-reload' />
        </svg>{' '}
        {this.props.children}
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/components/LivePoll/RetryButton/RetryButton.js